import React from "react";
import { Navigate } from "react-router-dom";
import { hasLocalAuthSession } from "../utils/authStorage";

const ProtectedRoute = ({ children }) => {
  if (!hasLocalAuthSession()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
